let total_accounts = 0;
let temp = 100;
let check = false;
let total_followers = 0;
let form_submitted = false;
let csv_file = true;
let xls_file = true;
window.course_with_tags = [];
let tag_s = "";

window.delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

$(document).ready(function () {
  if ($('.user_management_page').length > 0)
  {
    $.get("/users/invite_methods").done(function (data){
      $("#initial-user-invite-loader").css("display","none");
      $("#initial-user-invite-options").css("display", "block");
    });
  }
  
  $('.modal-for-profile-tag').click(function(event) {
    return $($(event.target).attr("data_link")).openModal();
  });

  let ref = $(".popup-edit-user-tag");
  for (let i = 0, len = ref.length; i < len; i++) {
    let tag = ref[i];
    course_with_tags.push($(tag).attr("course_id"));
  }

  $('.user-tags-custom-box').click(function(event) {
    const class_names = $(this).attr('class');
    const tag = "#" + $(this).parent().attr('tags_id').toString();
    const tag_1 = window.tag_s + $(this).parent().attr('tags_id').toString();
    if (class_names.indexOf('user-available-tag') !== -1) {
      $(this).removeClass('user-available-tag');
      $(this).addClass('user-selected-tag');
      $(this).find('.tag-close').text('x');
      const names = $(event.target).attr("class");
      if (names.indexOf("country") !== -1) {
        $(this).find('.tag-label').removeClass('tag-label-country');
        $(this).find('.tag-label').addClass('tag-label-country-full');
      } else if (names.indexOf("office") !== -1) {
        $(this).find('.tag-label').removeClass('tag-label-office');
        $(this).find('.tag-label').addClass('tag-label-office-full');
      } else if (names.indexOf("role") !== -1) {
        $(this).find('.tag-label').removeClass('tag-label-role');
        $(this).find('.tag-label').addClass('tag-label-role-full');
      }
      $(tag).val($(tag).val().concat(',' + $(this).find('.tag-label').text()));
      $(tag_1).val($(tag_1).val().concat(',' + $(this).find('.tag-label').text()));
    }
    else if (class_names.indexOf('user-selected-tag') !== -1) {
      $(this).removeClass('user-selected-tag');
      $(this).addClass('user-available-tag');
      $(this).find('.tag-close').text('+');
      const names = $(event.target).attr("class");
      if (names.indexOf("country") !== -1) {
        $(this).find('.tag-label').addClass('tag-label-country');
        $(this).find('.tag-label').removeClass('tag-label-country-full');
      } else if (names.indexOf("office") !== -1) {
        $(this).find('.tag-label').addClass('tag-label-office');
        $(this).find('.tag-label').removeClass('tag-label-office-full');
      } else if (names.indexOf("role") !== -1) {
        $(this).find('.tag-label').addClass('tag-label-role');
        $(this).find('.tag-label').removeClass('tag-label-role-full');
      }
      const tag_used = $(tag).val().split(',');
      const match_index = tag_used.indexOf($(this).find('.tag-label').text());
      if (match_index !== -1) {
        tag_used.splice(match_index, 1);
        $(tag).val(tag_used.join(','));
        $(tag_1).val(tag_used.join(','));
      }
    }
  });

  add_users_all_popups();

  $(".role-ids").each(function(){
    if(rails_variables.roles[$(this).val()] === rails_variables.manager_role) {
      $("#usermodal .followers").hide();
      $("#usermodal .not-required-by-manager").hide();
      $("#usermodal .um-popup-courses").hide();
    } else {
        $("#usermodal .not-required-by-manager").show();
        $("#usermodal .um-popup-courses").show();
    }
  });

  $(".role-ids").change(function(){
    const roles = rails_variables.roles;
    const manager_role = rails_variables.manager_role;
    if($("#current_role").val() !== $(this).val()){
      $("#usermodal .um-tabs-manager-followers").hide();
    } else {
      $("#usermodal .um-tabs-manager-followers").show();
    }
    if(roles[$(this).val()] === manager_role){
      $("#usermodal .not-required-by-manager").hide();
      $("#usermodal .um-popup-courses").hide();
      $("#usermodal .modalmain-container").animate({
        height: "465px"
      },800);
    } else {
      $("#usermodal .not-required-by-manager").show();
      $("#usermodal .um-popup-courses").show();
      $("#usermodal .modalmain-container").animate({
        height: "675px"
      },800);
    }
  });

  $('.validate-field').change(function(){
    if($(this).val() === ''){
      $(this).css('box-shadow', '1px 2px 0 rgba(225, 0, 0, 0.5) inset');
      $(this).css('border-right', '1px solid rgba(225, 0, 0, 0.5)');
      $(this).css('border-bottom', '1px solid rgba(225, 0, 0, 0.5)');
    } else {
      $(this).css('box-shadow', '1px 2px 0 rgba(0, 0, 0, 0.2) inset');
      $(this).css('border-right', '1px solid #dcdcdc');
      $(this).css('border-bottom', '1px solid #dcdcdc');
      if($(this).attr('id') === 'email') {
        let email = $(this);
        delay(function () {
          $.ajax({
            url: '/users/check_existing_email',
            type: 'GET',
            data: {email: $(email).val()},
            dataType: 'script',
            success: function (data) {
              if (data === 'false') {
                $(email).parents('form').find('.email-error').show();
                $(email).css('box-shadow', '1px 1px 0 rgba(225, 0, 0, 0.5) inset');
                $(email).css('border-right', '1px solid rgba(225, 0, 0, 0.5)');
                $(email).css('border-bottom', '1px solid rgba(225, 0, 0, 0.5)');
              } else {
                $(email).parents('form').find('.email-error').hide();
                $(email).css('box-shadow', '1px 1px 0 rgba(0, 0, 0, 0.2) inset');
                $(email).css('border-right', '1px solid #dcdcdc');
                $(email).css('border-bottom', '1px solid #dcdcdc');
              }
            }
          });
        }, 500);
      }
    }
  });

  $('label[for^=send_invite_], label[for^=get_invite_code_]').click(function(event){
    if($(this).html() === 'Get Invitation Code') {
      $(this).parents('form').find('#commit').val("Get Invitation Code");
    } else {
      $(this).parents('form').find('#commit').val("");
    }
  });

  $(".course-update-start-date").datepicker({dateFormat: 'yy-mm-dd'});
  $(".courses-start-dates").find("input[type='text']").datepicker({dateFormat: 'yy-mm-dd'});

  if ($('#user_role_ids').length !== 0)
  {
    if ($('#user_role_ids').val() === $('#manager_id').val())
      $("#manager-list-following").css("display", "block");
  } else if ($('#role').length !== 0)
  {
    if ($('#role').val() === $('#manager_id').val())
      $("#manager-list-following").css("display", "block");
  }

  $(".users-open_invite #first_day").datepicker({
   dateFormat: "yy-mm-dd"
  });

  $('#show-add-group').on('click', function ()
  {
    $(".adding-group").css("display", "block");
    $(".list-of-groups").css("display", "none");
  });

  $('#close-new-group').on('click', function ()
  {
    $(".adding-group").css("display", "none");
    $(".list-of-groups").css("display", "block");
  });

  $("#menuMobileToggle").on("click", function (e) {
    e.preventDefault();
    $('#hoofdmenu').slideToggle(300);
    $("#menuMobileToggle").toggleClass("toggled");
  });

  function emailRegex(value, callback) {
    if (value.length === 0) {
      alert('Email is a required field.');
    }
    if (/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i.test(value)) {
      callback(true);
    } else {
      alert('Invalid email format.');
      callback(false);
    }
  }

  function dateFormat(value, callback) {
    const date = new Date(value.toString());
    if (!!date && date.toString() !== 'Invalid Date') {
      callback(true);
    } else {
      alert("Invalid date format. Example: 'yyyy-mm-dd'");
      callback(false);
    }
  }

  callback_functions();

  $('.l-s-filter-cont .datepicker').change(function () {
    $(this).parents('form').submit();
  });

  $('.user-name').click(function () {
    $(this).hide();
    $(this).next().show();
    $(this).next().focus();
    let value = $(this).parents('li').next().find('.user-email-input').val();
    $(this).parents('li').next().find('.user-email-input').hide();
    $(this).parents('li').next().find('.user-email').show();
    $(this).parents('li').next().find('.user-email').find('.email-text').text(value);
  });

  $('.user-email').click(function () {
    $(this).hide();
    $(this).next().show();
    $(this).next().focus();
    let value = $(this).parents('li').prev().find('.user-fullname-input').val();
    $(this).parents('li').prev().find('.user-fullname-input').hide();
    $(this).parents('li').prev().find('.user-name').show();
    $(this).parents('li').prev().find('.user-name').find('.fullname-text').text(value);
  });

  $(".group_select").multiSelect(null, function (el) {
    $("#callbackResult").show().fadeOut();
  });

  $('.multiselectcs label').click(function(){
    let groups = [];
    $.each($(this).parents('.multiselectcs').find('label'), function (index, value) {
      if($($(value).get(0)).hasClass('checked') && !($($(value).get(0)).hasClass('selectAll'))) {
        groups.push($($(value).find('input').get(0)).val());
      }
    });
    $(this).parents('.multiselectcs').find('#user_group_ids').val(groups);
    $(this).parents('.multiselectcs').find('#groups span').text(groups.length + " selected")
    $(this).parents('.multiselectcs').find('.multiSelect span').text(groups.length + " selected")
  });

  $('.users .multiselect-groups label').click(function(event){
    if (event.target.tagName == "INPUT")
    {
      let groups_checked = [];
      if ($(this).find('input').val() == "all")
      {
        groups_checked = ["All"];
        $.each($(this).parents('.multiselect-groups').find('label'), function (index, value) {
          if ($($(value).find('input').get(0)).val() != "all" && !($($(value).get(0)).hasClass('selectAll')))
          {
            $($(value).get(0)).removeAttr('class');
            $(value).find('input').get(0).checked = false;
          }
        });
      }
      else if ($(this).find('input').val() == "none")
      {
        groups_checked = ["None"];
        $.each($(this).parents('.multiselect-groups').find('label'), function (index, value) {
          if ($($(value).find('input').get(0)).val() != "none" && !($($(value).get(0)).hasClass('selectAll')))
          {
            $($(value).get(0)).removeAttr('class');
            $(value).find('input').get(0).checked = false;
          }
        });
      }
      else
      {
        $.each($(this).parents('.multiselect-groups').find('label'), function (index, value) {
          if ($($(value).find('input').get(0)).val() == "all" || $($(value).find('input').get(0)).val() == "none")
          {
            $($(value).get(0)).removeAttr('class');
            $(value).find('input').get(0).checked = false;
          }
          else if ($($(value).get(0)).hasClass('checked'))
          {
            groups_checked.push($($(value).get(0)).text());
          }
        });
      }
      
      $('#groups span').text(groups_checked.length + " selected")

      const checked = [];
      $.each($('.roles-filter .lso-checkbox').children().find('input'), function (index, value) {
        if (value.checked) {
          checked.push($(value).next('label').text());
        }
      });
      let data = "Roles: " + checked.join(', ');
      if (checked.length > 0) {
        add_filter_tag(data, 'roles');
        $('#unselect_groles').val(false);
      } else {
        $('#roles').hide();
      }

      data = "Groups: " + groups_checked.join(', ');
      if (groups_checked.length > 0) {
        add_filter_tag(data, 'groups-filter');
        $('#unselect_groups').val(false);
      } else {
        $('#groups-filter').hide();
      }
      $('#search-groups').val('');
      search_groups();
      $(this).parents('form').submit();
    }
  });

  $('.user-fullname-input').on('keydown', function(event) {
    if(event.keyCode === 13) {
      event.preventDefault();
      const value = $(this).val();
      $(this).hide();
      $(this).prev().find('.fullname-text').text(value);
      $(this).prev().show();
    }
  });

  $('.user-email-input').on('keydown', function(event) {
    if(event.keyCode === 13) {
      event.preventDefault();
      const value = $(this).val();
      $(this).hide();
      $(this).prev().find('.email-text').text(value);
      $(this).prev().show();
    }
  });

  $('.user_management_page #user_avatar').change(function(){
    let file, file_preview, input, reader, fileObject = {};
    file_preview = $(event.target).parent();
    input = $(event.currentTarget);
    file = input[0].files[0];
    if (!file) {
      return;
    }
    fileObject.filetype_image = file.type;
    fileObject.filename_image = file.name;
    reader = new FileReader();
    reader.onload = function (e) {
      let image_base64;
      image_base64 = e.target.result;
      file_preview.css("background-image", "url("+image_base64+")");
      $(file_preview).find('a').hide();
    };
    reader.readAsDataURL(file);
  });

  $("#o_tab_2").on("ajax:success", "td a.del-icon", function(event, data, status, xhr) {
    $(event.target).parents('tr').fadeOut("slow", function() {
      $(this).remove();
      $('.open-invite-deleted-feedback').fadeIn('slow');
      $('.modal').animate({scrollTop: 0}, 'slow');
      $('.open-invite-tab-content').animate({scrollTop: 0}, 'slow');
      setTimeout(function(){
        $('.open-invite-deleted-feedback').fadeOut('slow');
      }, 3000);
    });
  });

  let updateOpenInviteModal = '';
  $('.update-open-invite-btn').click(function(){
    $(this).parents('form').submit();
    updateOpenInviteModal = $(this).parents('.modal').attr('id');
  });

  $('.update-open-invite-form').on('ajax:success', function(event, data){
    if (event.target.tagName === "FORM")
    {
      $('#' + updateOpenInviteModal).closeModal();
      setTimeout((function() {
        $('#modal_openInvite').openModal();
      }), 250);
      $('.open-invites-list').html(data);
      add_users_all_popups();
      $('.open-invite-updated-feedback').fadeIn('slow');
      $('.modal').animate({scrollTop: 0}, 'slow');
      $('.open-invite-tab-content').animate({scrollTop: 0}, 'slow');
      setTimeout(function(){
        $('.open-invite-updated-feedback').fadeOut('slow');
      }, 3000);
    }
  });

  if($('#invitation_sent_modal').length > 0) {
    $('#invitation_sent_modal').openModal();
    window.history.pushState({}, null, window.location.origin+window.location.pathname);
  }
  if($('#csv_import_success_modal').length > 0) {
    $('#csv_import_success_modal').openModal();
    window.history.pushState({}, null, window.location.origin+window.location.pathname);
  }

  if($('#invitation_code_modal').length > 0) {
    $('#invitation_code_modal').openModal();
    window.history.pushState({}, null, window.location.origin+window.location.pathname);
  }

  if($('#open_invitation_code_modal').length > 0) {
    $('#open_invitation_code_modal').openModal();
    window.history.pushState({}, null, window.location.origin+window.location.pathname);
  }

  if($('#reset_password_modal').length > 0) {
    $('#reset_password_modal').openModal();
    window.history.pushState({}, null, window.location.origin+window.location.pathname);
  }

  if($('#reset_form_data_modal').length > 0) {
    $('#reset_form_data_modal').openModal();
    window.history.pushState({}, null, window.location.origin+window.location.pathname);
  }

  $('.d_clip_button').click(function(){
    $('.copied-to-clipboard').show();
    $('.copied-from-clipboard').hide();
    $('.d_clip_button').hide();
  });

  $("[data-users]").on("keyup", function (event) {
    let input, filter, container, li, a, i;
    input = $(this);
    filter = input.get(0).value.toUpperCase();
    container = input.parents('.sim-popup-content').find("#manager-followings");
    li = container.get(0).getElementsByTagName('li');

    // Loop through all list items, and hide those who don't match the search query
    for (let i = 0; i < li.length; i++) {
      const h5 = li[i].getElementsByTagName("h5")[0];
      if (h5.innerHTML.toUpperCase().indexOf(filter) > -1) {
        $(li[i]).parents('.col.l6.m6.left').show();
      } else {
        $(li[i]).parents('.col.l6.m6.left').hide();
      }
    }
  });

  $('.modal-for-user-app').click(function (event) {
    $("#usermodal").openModal({dismissible: false});
    $("#usermodal").html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>');
  });

  if($('.multiselect-groups.with-search').length == 1) {
    $('.multiselect-groups.with-search').find('.multiSelectOptions').prepend('<input id="search-groups" type="text" autocomplete="off">');

    $('#search-groups').on("keyup", function(event) {
      search_groups();
    });
  }
});

function search_groups() {
  let text = $('#search-groups').val().toLowerCase();
  $.each($('.multiselect-groups.with-search .multiSelectOptions').find('label'), function(index, item) {
    if($(item).text().toLowerCase().indexOf(text) != -1 && !($(item).hasClass('selectAll'))) {
      $(item).show();
    } else {
      $(item).hide();
    }
  });
}

function check_if_selected_course_have_tags(event) {
  const back_modal = "#" + $(event.target).attr("data-back");
  const next_modal = "#" + $(event.target).attr("data-next");
  const role_modal = $(event.target).attr("data-role");
  $(event.target).attr("href", next_modal);
  let course_with_tags_selected = [];
  if (role_modal === "viewer")
  {
    window.tag_s = "#vi_";
    const courses_id = "v_course";
    ref = $("input[id^='v_course']:checked");
  }
  else if (role_modal === "editor")
  {
    window.tag_s = "#ei_";
    const courses_id = "e_course";
    ref = $("input[id^='e_course']:checked");
  }
  else
  {
    window.tag_s = "#umi_";
    const courses_id = "um_course";
    ref = $("input[id^='um_course']:checked");
  }
  for (let i = 0, len = ref.length; i < len; i++) {
    const tag = ref[i];
    const match_index = course_with_tags.indexOf($(tag).attr("id").split(courses_id)[1]);
    if (match_index !== -1) {
      course_with_tags_selected.push($(tag).attr("id").split(courses_id)[1]);
    }
  }
  for (let i = 0, len = course_with_tags_selected.length; i < len; i++) {
    if ((i-1) > -1)
    {
      $('#tag-'+course_with_tags_selected[i]).find('.back-tag').attr("href", "#tag-"+course_with_tags_selected[i-1]);
      $('#tag-'+course_with_tags_selected[i]).find('.next-tag').attr("href", next_modal);
      $('#tag-'+course_with_tags_selected[i-1]).find('.next-tag').attr("href", "#tag-"+course_with_tags_selected[i]);
    }
    else
    {
      $('#tag-'+course_with_tags_selected[i]).find('.back-tag').attr("href", back_modal);
      $('#tag-'+course_with_tags_selected[i]).find('.next-tag').attr("href", next_modal);
      $(event.target).attr("href", '#tag-'+course_with_tags_selected[i]);
    }
    $('#tag-' + course_with_tags_selected[i]).find('.sub-heading').html("single invite - " + $('#tag-' + course_with_tags_selected[i]).find('.sub-heading').html().split(" - ")[1]);
  }
};

window.add_users_all_popups = function(){
  $('.add-users-all-popups').unbind( "click" );
  $('.add-users-all-popups').click(function (event) {
    let submit_form = false;
    let validate_form = false;
    let validated = true;
    let validate_email = false;
    let modal_to_open, modal_to_close;
    if($(this).hasClass('form-submit-button')) {
      submit_form = true;
      if ($(this).hasClass('disable-click'))
      {
        $(this).css("pointer-events", "none");
      }
    }
    if($(this).hasClass('form-validation-button')) {
      validate_form = true;
      validated = false;
    }
    if($(this).hasClass('validate-email')) {
      validate_email = true;
      let email = $(this).parents('form').find('#email');
      if(!!$(email).val()) {
        $.ajax({
          url: '/users/check_existing_email',
          type: 'GET',
          data: {email: $(email).val()},
          dataType: 'script',
          success: function (data) {
            if (data === 'false') {
              $(email).parents('form').find('.email-error').show();
              $(email).css('box-shadow', '1px 1px 0 rgba(225, 0, 0, 0.5) inset');
              $(email).css('border-right', '1px solid rgba(225, 0, 0, 0.5)');
              $(email).css('border-bottom', '1px solid rgba(225, 0, 0, 0.5)');
              return;
            } else {
              $(email).parents('form').find('.email-error').hide();
              $(email).css('box-shadow', '1px 1px 0 rgba(0, 0, 0, 0.2) inset');
              $(email).css('border-right', '1px solid #dcdcdc');
              $(email).css('border-bottom', '1px solid #dcdcdc');
              if (validated && !submit_form && validate_email) {
                if (modal_to_open !== '#') {
                  $('#' + modal_to_close).closeModal();
                  setTimeout((function () {
                    $(modal_to_open).openModal();
                  }), 250);
                }
                validate_email = false;
              }
            }
          }
        });
      }
    }
    modal_to_close = $($(event.target).parents('.modal')[0]).attr("id");
    if (modal_to_close === undefined) {
      modal_to_close = $(event.target).data("modal-to-close");
    }
    if ($(event.target).attr("id") === "check-for-courses-tags")
    {
      const role_modal = $(event.target).attr("data-role");
      if (role_modal === "viewer")
      {
        const ref = $("input[id^='v_course']:checked");
      }
      else if (role_modal === "editor")
      {
        const ref = $("input[id^='e_course']:checked");
      }
      else
      {
        const ref = $("input[id^='um_course']:checked");
      }
      if (ref.length == 0)
      {
        alert ("Please select atleast one course.");
        return;
      }
      check_if_selected_course_have_tags(event);
    }
    else if ($(event.target).attr("id") === "check-for-manager-preset")
    {
      const ref = $("input[id^='m_preset']:checked");
      if (ref.length == 0)
      {
        alert ("Please select a manager preset.");
        return;
      }
    }
    else if ($(event.target).attr("href") === "#submit-new-open-invite")
    {
      $('#new_open_code').attr("id", "submit_new_open_code");
      $("#submit_new_open_code").submit();
      return;
    }
    else if ($(event.target).attr("href") === "#submit-import-user-form")
    {
      $('#import-user-form').attr("id", "submit-import-user-form");
      $("#submit-import-user-form").submit();
      return;
    }
    if ($(event.target)[0].nodeName === "A")
    {
      modal_to_open = $(event.target).attr("href");
    }
    else
    {
      modal_to_open = $(event.target).parent().attr("href");
    }
    if (modal_to_open == "#modal_suViewer6" && ($('#is-user-external-manager').attr('data-external-manager') == "true") && $("input[id^='v_groups']:checked").length == 0)
    {
      alert ("Please select atleast one group.");
      return;
    }
    else if (modal_to_open == "#modal_suusermanager5" && ($('#is-org-external-manager').attr('data-external-manager') == "true") && $("input[id^='um_groups']:checked").length == 0)
    {
      alert ("Please select atleast one group.");
      return;
    }
    else if (modal_to_open == "#modal_sureporter3" && ($('#is-org-external-reporter').attr('data-external-reporter') == "true") && $("input[id^='r_groups']:checked").length == 0)
    {
      alert ("Please select atleast one group.");
      return;
    }
    else if (modal_to_open == "#modal_sueditor5" && ($('#is-org-external-editor').attr('data-external-manager') == "true") && $("input[id^='e_groups']:checked").length == 0)
    {
      alert ("Please select atleast one group.");
      return;
    }
    if(submit_form) {
      if ($(this).parents('form').attr("id") == 'new_open_code' && $("#new_open_code input[id^='course']:checked").length == 0)
      {
        alert ("Please select atleast one course.");
        setTimeout(function(){
          $('#new_open_code input:submit').removeAttr("disabled");
        }, 1000);
      }
      else
      {
        $(this).parents('form').submit();
      }
    }
    if(validate_form) {
      let fname = $(this).parents('form').find('#first_name');
      let lname = $(this).parents('form').find('#last_name');
      let email = $(this).parents('form').find('#email');
      if($(fname).val() === '' || $(lname).val() === '' || $(email).val() === '') {
        validated = false;
      } else {
        validated = true;
      }
      if($(fname).val() !== '') {
        $(fname).css('box-shadow', '1px 2px 0 rgba(0, 0, 0, 0.2) inset');
        $(fname).css('border-right', '1px solid #dcdcdc');
        $(fname).css('border-bottom', '1px solid #dcdcdc');
      } else {
        $(fname).css('box-shadow', '1px 2px 0 rgba(225, 0, 0, 0.5) inset');
        $(fname).css('border-right', '1px solid rgba(225, 0, 0, 0.5)');
        $(fname).css('border-bottom', '1px solid rgba(225, 0, 0, 0.5)');
      }
      if($(lname).val() !== '') {
        $(lname).css('box-shadow', '1px 2px 0 rgba(0, 0, 0, 0.2) inset');
        $(lname).css('border-right', '1px solid #dcdcdc');
        $(lname).css('border-bottom', '1px solid #dcdcdc');
      } else {
        $(lname).css('box-shadow', '1px 2px 0 rgba(225, 0, 0, 0.5) inset');
        $(lname).css('border-right', '1px solid rgba(225, 0, 0, 0.5)');
        $(lname).css('border-bottom', '1px solid rgba(225, 0, 0, 0.5)');
      }
      if($(email).val() === '') {
        $(email).css('box-shadow', '1px 1px 0 rgba(225, 0, 0, 0.5) inset');
        $(email).css('border-right', '1px solid rgba(225, 0, 0, 0.5)');
        $(email).css('border-bottom', '1px solid rgba(225, 0, 0, 0.5)');
      }
    }
    if(validated && !submit_form && !validate_email){
      if(modal_to_open !== '#'){
        $('#' + modal_to_close).closeModal();
        setTimeout((function() {
          $(modal_to_open).openModal();
        }), 250);
      }
    }
  });
}

function callback_functions() {
  set_selected_users();
  $('.check-boxer input[type="checkbox"]').change(function () {
    if (this.checked) {
      $(this).parents(".check-boxer").siblings('.user-prof-inner').addClass("checked-gray");
    } else {
      $(this).parents(".check-boxer").siblings('.user-prof-inner').removeClass("checked-gray");
    }
    update_selected_users_count();
  });

  $('#search').keyup(function () {
    delay(function () {
      $('#search').parents('form').submit();
    }, 1000);
  });

  remove_filter_tags();

  $('#f-option').click(function () {
    const data = "Status: " + $(this).siblings('label').text();
    add_filter_tag(data, 'status');
    $('#unselect_status').val(false);
    $(this).parents('form').submit();
    $('.archived-status-count').html(0);
  });

  $('#s-option').click(function () {
    const data = "Status: " + $(this).siblings('label').text();
    add_filter_tag(data, 'status');
    $('#unselect_status').val(false);
    $('.archive-user').css('color', '#afb5bc');
    $('.archive-user').css('border', '1px solid #afb5bc');
    $(this).parents('form').submit();
    $('.active-status-count').html(0);
  });

  $('#t-option').click(function () {
    const data = "Status: " + $(this).siblings('label').text();
    add_filter_tag(data, 'status');
    $('#unselect_status').val(false);
    $(this).parents('form').submit();
  });

  $('.user_management_page .datepicker').change(function () {
    let data;

    if (!!$(this).val()) {
      switch ($(this).attr('name')) {
        case 'user[start][hidden]':
          data = "From: " + $(this).val();
          add_filter_tag(data, 'from');
          break;
        case 'user[end][hidden]':
          data = "To: " + $(this).val();
          add_filter_tag(data, 'to');
          break;
        case 'user[first_day_start_date][hidden]':
          data = "First Day From: " + $(this).val();
          add_filter_tag(data, 'first_day_from');
          break;
        case 'user[first_day_end_date][hidden]':
          data = "First Day To: " + $(this).val();
          add_filter_tag(data, 'first_day_to');
          break;
        default:
          break;
      }
    } 
    else {
      switch ($(this).attr('name')) {
        case 'user[start][hidden]':
          $('#from').hide();
          break;
        case 'user[end][hidden]':
          $('#to').hide();
          break;
        case 'user[first_day_start_date][hidden]':
          $('#first_day_from').hide();
          break;
        case 'user[first_day_end_date][hidden]':
          $('#first_day_to').hide();
          break;
        default:
          break;
      }
    }
    if($(this).attr('id') !== 'user_first_day_hidden'){
      $(this).parents('form').submit();
    }
  });

  $("input[id^='roles_']").click(function () {
    if ($(this).next('label').text() === 'All') {
      $.each($('.roles-filter .lso-checkbox').children().find('input'), function (index, value) {
        if ($(value).next('label').text() !== 'All') {
          $(value).get(0).checked = false;
        }
      });
    } else {
      $('input#roles_all').get(0).checked = false;
    }
    $('#unselect_roles').val(false);
  });

  $("input[id^='groups_']").click(function () {
    if ($('input#groups_all').length > 0) {
      if ($(this).next('label').text() === 'All') {
        $.each($('.groups-filter .lso-checkbox').children().find('input'), function (index, value) {
          if ($(value).next('label').text() !== 'All') {
            $(value).get(0).checked = false;
          }
        });
      } else if ($(this).next('label').text() === 'None') {
        $.each($('.groups-filter .lso-checkbox').children().find('input'), function (index, value) {
          if ($(value).next('label').text() !== 'None') {
            $(value).get(0).checked = false;
          }
        });
      }else {
        $('input#groups_all').get(0).checked = false;
        if (!!$('input#groups_none').get(0))
        {
          $('input#groups_none').get(0).checked = false;
        }
      }
    }
  });

  $('.users .um-leftside .lso-checkbox input[type=checkbox]').click(function () {
    let checked = [];
    $.each($('.roles-filter .lso-checkbox').children().find('input'), function (index, value) {
      if (value.checked) {
        checked.push($(value).next('label').text());
      }
    });
    let data = "Roles: " + checked.join(', ');
    if (checked.length > 0) {
      add_filter_tag(data, 'roles');
      $('#unselect_groles').val(false);
    } else {
      $('#roles').hide();
    }
    checked = [];
    $.each($('.groups-filter .lso-checkbox').children().find('input'), function (index, value) {
      if (value.checked) {
        checked.push($(value).next('label').text());
      }
    });
    data = "Groups: " + checked.join(', ');
    if (checked.length > 0) {
      add_filter_tag(data, 'groups-filter');
      $('#unselect_groups').val(false);
    } else {
      $('#groups-filter').hide();
    }
    $(this).parents('form').submit();
  });

  $('#user_applications').change(function () {
    if (!!$(this).val()) {
      const data = "Organization: " + $(this).val();
      add_filter_tag(data, 'org');
    } else {
      $('#org').hide();
    }
    $(this).parents('form').submit();
  });

  $('.activate-user').click(function () {
    $('<input />').attr('type', 'hidden')
            .attr('name', 'commit')
            .attr('value', 'Activate')
            .appendTo('#filter-form');
    $(this).parents('form').submit();
  });

  $('.archive-user').click(function () {
    if(confirm('Are you sure?')) {
      $('<input />').attr('type', 'hidden')
        .attr('name', 'commit')
        .attr('value', 'Archive')
        .appendTo('#filter-form');
      $(this).parents('form').submit();
    }
  });

  $('.delete-user').click(function () {
    let button = $(this);
    if(confirm("You are about to delete archived user(s) Do you wish to continue?")) {
      $('<input />').attr('type', 'hidden')
              .attr('name', 'commit')
              .attr('value', 'Delete')
              .appendTo('#filter-form');
      $(button).parents('form').submit();
    }
  });

  $('#select-users').change(function () {
    if ($(this).val() === '1') {
      $.each($('.check-boxer input[type="checkbox"]'), function (index, value) {
        $(value).parents(".check-boxer").siblings('.user-prof-inner').addClass("checked-gray");
        $(value).get(0).checked = true;
        $('.archive-user').css('color', '#424C5A');
        $('.archive-user').css('border', '1px solid #424C5A');
      });
    } else if ($(this).val() === '2') {
      $.each($('.check-boxer input[type="checkbox"]'), function (index, value) {
        $(value).parents(".check-boxer").siblings('.user-prof-inner').removeClass("checked-gray");
        $(value).get(0).checked = false;
        $('.archive-user').css('color', '#afb5bc');
        $('.archive-user').css('border', '1px solid #afb5bc');
      });
    }
    update_selected_users_count();
  });

  $('#user_role_ids').change(function (e) {
    if ($(e.target).val() === $('#manager_id').val())
      $("#manager-list-following").css("display", "block");
    else
      $("#manager-list-following").css("display", "none");
  });

  $('.del-manager').click(function (e) {
    const id = $(e.target).attr("id");
    const remove_id = id.split("-")[1];
    const manager_ids = $(e.target).parents("#added-managers").children('.manager-ids');
    manager_ids.val(manager_ids.val().split(remove_id.toString()));
    if($(e.target).parents(".manager-details-pop").find("#add_a_manager option[value='" + remove_id +"']").length > 0){
      $(e.target).parents(".manager-details-pop").find("#add_a_manager option[value='" + remove_id +"']").css("display", "block");
    } else {
      $("#add_a_manager").append("<option value='"+ remove_id +"'>"+$(e.target).parent().parent().find("h5").text()+"</option>")
    }
    $(e.target).parents(".manager-details-pop").find("#add_a_manager").trigger("chosen:updated");
    $(e.target).parents(".user-details").remove();
  });

  $('#role').change(function (e) {
    if ($(e.target).val() === $('#manager_id').val())
      $("#manager-list-following").css("display", "block");
    else
      $("#manager-list-following").css("display", "none");
  });

  $('#filter-form').submit(function (e) {
    e.preventDefault();
    $('.user-management-filter-overlay').show();
    $.ajax({
      url: $('#filter-form').attr('action'),
      type: 'POST',
      data: $('#filter-form').serialize(),
      dataType: 'script',
      success: function (data) {
        $('.user-management-filter-overlay').hide();
      },
      error: function (data) {
        $('.user-management-filter-overlay').hide();
        alert('Error occured!');
      }
    });
    return false;
  });

  $('.user-avatar-field #user_avatar').change(function () {
    let file, file_preview, input, reader, fileObject = {};
    file_preview = $(event.target).siblings("img");
    input = $(event.currentTarget);
    file = input[0].files[0];
    if (!file) {
      return;
    }
    fileObject.filetype_image = file.type;
    fileObject.filename_image = file.name;

    reader = new FileReader();
    reader.onload = function (e) {
      let image_base64;
      image_base64 = e.target.result;
      file_preview.attr("src", image_base64);
    };
    reader.readAsDataURL(file);
  });
}

function set_selected_users() {
  $.each($('.check-boxer input[type="checkbox"]'), function (index, value) {
    if (value.checked) {
      $(value).parents(".check-boxer").siblings('.user-prof-inner').addClass("checked-gray");
    } else {
      $(value).parents(".check-boxer").siblings('.user-prof-inner').removeClass("checked-gray");
    }
    if ($('#f-option').length > 0) {
      if ($('#f-option').get(0).checked) {
        $('.active-status-count').html($(".checked-gray").length);
      } else if ($('#s-option').get(0).checked) {
        $('.archived-status-count').html($(".checked-gray").length);
      }
    }
  });
}

function update_selected_users_count() {
  if ($('#f-option').get(0).checked) {
    let selected = $(".checked-gray").length;
    $('.active-status-count').html(selected);
    if(selected > 0) {
      $('.archive-user').css('color', '#424C5A');
      $('.archive-user').css('border', '1px solid #424C5A');
    } else {
      $('.archive-user').css('color', '#afb5bc');
      $('.archive-user').css('border', '1px solid #afb5bc');
    }
  } else if ($('#s-option').get(0).checked) {
    $('.archived-status-count').html($(".checked-gray").length);
    $('.archive-user').css('color', '#afb5bc');
    $('.archive-user').css('border', '1px solid #afb5bc');
  } else if ($('#t-option').get(0).checked) {
    let active_users = 0;
    let archive_users = 0;
    let ref = $(".checked-gray");
    for (let i = 0, len = ref.length; i < len; i++)
    {
      if (($(ref[i]).find('.user-archived-status').css("display")) === "none")
      {
        active_users++;
      }
      else
      {
        archive_users++;
      }
    }

    $('.active-status-count').html(active_users);
    if(active_users > 0) {
      $('.archive-user').css('color', '#424C5A');
      $('.archive-user').css('border', '1px solid #424C5A');
    } else {
      $('.archive-user').css('color', '#afb5bc');
      $('.archive-user').css('border', '1px solid #afb5bc');
    }
    $('.archived-status-count').html(archive_users);
    $('.archive-user').css('color', '#afb5bc');
    $('.archive-user').css('border', '1px solid #afb5bc');
  }
}

function remove_filter_tags() {
  $('.filter-tag').click(function () {
    let id = $(this).parents('li').attr('id');
    if (id === 'org') {
      $('#user_applications').val('');
      $('#user_applications').trigger("chosen:updated");
    } else if (id === 'from') {
      $('#user_start_hidden').val('');
      $('#user_start').val('')
    } else if (id === 'to') {
      $('#user_end_hidden').val('');
      $('#user_end').val('');
    } else if (id === 'first_day_from'){
      $('#user_first_day_start_date_hidden').val('');
      $('#user_first_day_start_date').val('');
    } else if (id === 'first_day_to'){
      $('#user_first_day_end_date_hidden').val('');
      $('#user_first_day_end_date').val('');
    } else if (id === 'status') {
      $('#f-option').get(0).checked = false;
      $('#s-option').get(0).checked = false;
      $('#t-option').get(0).checked = false;
      $('#unselect_status').val(true);
    } else if (id === 'groups-filter') {
      $.each($('.groups-filter .lso-checkbox').children().find('input'), function (index, value) {
        $(value).get(0).checked = false;
      });
      $.each($('.multiselect-groups').find('label'), function (index, value) {
        $($(value).get(0)).removeAttr('class');
        $(value).find('input').get(0).checked = false;
      });
      $('#groups span').text("0 selected");
      $('#unselect_groups').val(true);
    } else if (id === 'roles') {
      $.each($('.roles-filter .lso-checkbox').children().find('input'), function (index, value) {
        $(value).get(0).checked = false;
      });
      $('#unselect_roles').val(true);
    }
    $(this).parents('form').submit();
    $(this).parents('li').hide(200);
  });
}

function add_filter_tag(data, container_id) {
  const label = $('<span></span>').text(data);
  const removeLink = $('<a href="#"><i class="filter-tag fa fa-times" aria-hidden="true"></i></a>');
  $('.c-filters').find('#' + container_id).empty().append(label, removeLink);
  $('.c-filters').find('#' + container_id).show(200);
  remove_filter_tags();
}

window.user_file_preview = function(selected_user_files) {
  let fi = $(selected_user_files).children().last().find('.uploaded-file-name');

  $($(selected_user_files).children().last().find('.img-preview')).change(function (event) {
    let file, input, reader;
    $(selected_user_files).children().last().css("display", "block");
    input = $(event.currentTarget);
    file = input[0].files[0];
    reader = new FileReader();
    reader.onload = function (e) {
      let image_base64;
      image_base64 = e.target.result;
      $(fi).text(file.name);
    };
    reader.readAsDataURL(file);
  });
  $(selected_user_files).children().last().find('.img-preview').click();
}

window.remove_user_file_fields = function(link) {
  $(link).siblings().val(1);
  $(link).parent().parent().remove();
}

function check_last_user_file(selected_user_files) {
  if ($(selected_user_files).children().last().find('.img-preview').val() === "")
  {
    $(selected_user_files).children().last().remove();
  }
}

window.add_user_file_fields = function(link, association, fields_to_clone, view) {
  selected_user_files = $(link).parents(".um-popup-files").children("#user-private-files").children('.user-files');
  check_last_user_file(selected_user_files);

  if (view === 'new') {
    total_accounts++;
  } else {
    temp++;
    total_accounts = temp;
  }

  let regexp = new RegExp("new_" + association, "g");
  selected_user_files.append(fields_to_clone.replace(regexp, total_accounts));

  user_file_preview(selected_user_files);
}

window.add_follower_fields = function(link, association, fields_to_clone, view) {
  if (view === 'new')
  {
    total_followers++;
  } else
  {
    temp++;
    total_followers = temp;
  }
  let regexp = new RegExp("new_" + association, "g");
  $(link).parent().parent().parent().children(".followers").append(fields_to_clone.replace(regexp, total_followers));
  $(function () {
    return $('select.chosen-select').chosen({
      allow_single_deselect: true,
      no_results_text: 'No results matched',
      width: '100%'
    });
  });
}

window.remove_follower_fields = function(link) {
  $(link).siblings().val(1);
  $(link).parent().parent().remove();
}
